import { localStorageProxy } from '#app/lib/local_storage'
import { info, logError } from '#app/lib/loggers'
import { treq, treqPartial } from '#app/lib/treq'
import type { Email } from '#server/types/user'
import { mainUser } from '#user/lib/main_user'

export const requestSignup = treqPartial('auth', 'post', 'signup')

export function passwordConfirmation (currentPassword: string) {
  const { username } = mainUser
  // Using the login route to verify the password validity
  return requestLogin({ username, password: currentPassword })
}

export const requestLogin = treqPartial('auth', 'post', 'login')

export async function passwordUpdate ({ currentPassword, newPassword }: { currentPassword?: string, newPassword: string }) {
  await treq('auth', 'put', 'password', {
    'old-password': currentPassword,
    'new-password': newPassword,
  })
}

export async function passwordResetRequest (email: Email) {
  await treq('auth', 'post', 'reset-password', { email })
}

export const emailConfirmationRequest = treqPartial('auth', 'post', 'email-confirmation')

export async function requestLogout (redirect?: string) {
  try {
    console.trace('logout', { redirect })
    await treq('auth', 'post', 'logout')
    // Clearing localstorage
    localStorageProxy.clear()
    info('You have been successfully logged out')
    // Default to redirecting home
    window.location.href = redirect || '/'
  } catch (err) {
    logError(err, 'logout error')
  }
}
